export default __webpack_public_path__ + "static/media/diamond_bee_icon.51b5f5d6.svg";